<div class="page">
    <div class="container-fluid">
        <div class="row page-header">
            <div class="col-md-6">
                <h3>Faculty Attendance </h3>

                
            </div>

            <div class="col-md-6 text-right">
                
                <span class="date-nav" (click)="backwardDate()">
                    &lt;
                </span>
                
                <input class="selected-date" [ngClass]="(formattedDate(date) == formattedDate(today)) ? 'today' : ''" type="date" value="{{formattedDate(date)}}" (change)="setCustomDate($event.target.value)"/>

                <span class="date-nav" (click)="forwardDate()" *ngIf="formattedDate(date) != formattedDate(today)">
                    &gt;
                </span>

                <span class="date-nav" *ngIf="formattedDate(date) == formattedDate(today)" style="visibility: hidden;">
                    
                </span>

            </div>
        </div>

        <div class="page-body">
            <table class="table table-borderless table-striped">
                <thead>
                    <td style="width: 20%;">Faculty Name</td>
                    <td>Attendance</td>
                </thead>

                <tbody>
                    <ng-container *ngIf="data.list.length > 0; else noData">
                        <ng-container *ngFor="let faculty of data.list">
                            <tr *ngIf="faculty.role.id != 1">
                                <td>
                                    {{faculty.name}}
                                </td>

                                <td *ngIf="!isHoliday">
                                    <button class="btn btn-sm" 
                                        [ngClass]="(!attendance[faculty.id] || attendance[faculty.id] == 1) ? 'btn-success' : 'btn-outline-dark' " 
                                        (click)="markAttendance(faculty.id, 1)"
                                    >
                                        Present
                                </button>
                                &nbsp;

                                    <button class="btn btn-sm"
                                        [ngClass]="(attendance[faculty.id] && attendance[faculty.id] == 2) ? 'btn-danger' : 'btn-outline-dark' "
                                        (click)="markAttendance(faculty.id, 2)">
                                        Absent
                                </button>

                                </td>
                                <td *ngIf="isHoliday">
                                    <span class="badge badge-warning">HOLIDAY</span>
                                </td>
                            </tr>
                        </ng-container> 
                    </ng-container>
                    <ng-template #noData>
                        <tr>
                           <td colspan="2" class="text-center">
                            No Faculty found!
                           </td> 
                        </tr>
                    </ng-template>
                </tbody>

            </table>
            <div class="row" style="margin-bottom: 30px;">
                <div class="col-md-6">
                  <img src="assets/img/icon-arrow-left-active.svg" class="btn btn-nav" *ngIf="offset > 0" (click)="paginate(1)" />
                </div>
                <div class="col-md-6 text-right">
                  <img src="assets/img/icon-arrow-right-active.svg" class="btn btn-nav" *ngIf="data.count > offset+limit" (click)="paginate(2)" />
                </div>
            </div>
        </div>
    </div>
</div>